import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CardGrey from "../components/CardGrey";
import CardWhite from "../components/CardWhite";
import { ArrowUpRight } from "phosphor-react";
import VideoTestimonial from "../components/VideoTestimonial";
import DarkRedButton from "../components/DarkRedButton";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { useMediaPredicate } from "react-media-hook";
import { carousel_images } from "../Images/home/hero_carousel/carouselImages";
import { carousel_images_mobile } from "../Images/home/hero_carousel_mobile/carouselImagesMobile";
import { getAllPhotos } from "../utils/Helpers";
import PropertyMap from "./PropertyMap";
import HomeStatesHighlight from "./HomeStatesHighlight";
import { SHOW_HOME_STATES_HIGHLIGHT } from "../config/featureFlags";
import GalerieProjectsSlider from "../components/GalerieProjectsSlider";
import CoreStackSlider from "../components/CoreStackSlider";
// RollingWord.js is kept in components/ for later — swapped out below for
// the typewriter effect.
import TypewriterWord from "../components/TypewriterWord";
import { Parallax } from "react-scroll-parallax";
import { useScrollDirection } from "react-use-scroll-direction";
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

export default function Home({ storage, db, handleCurrentPage, slide_right, setNavBackground, setNavText }) {
  const [hoverColor, setHoverColor] = useState(false);
  const max_width = useMediaPredicate("(max-width: 760px)");
  const max_width2 = useMediaPredicate("(max-width: 1230px)");
  const { isScrollingUp, isScrollingDown, isScrolling } = useScrollDirection();
  const [scroll, setScroll] = useState(false);
  const hoverCard = (div) => {
    setHoverColor(div);
  };

  const handleScroll = () => {
    const x = scroll;
    if (isScrollingDown === true) {
      setScroll(true);
    }
    if (isScrollingUp === true) {
      setScroll(false);
    }
    if (isScrolling === false) {
      setScroll(x);
    }
  };
  useEffect(() => {
    handleCurrentPage();
    window.scroll(0, 0);
    getAllPhotos("home");
    getAllPhotos("contact");

    setNavBackground("transparent");
    setNavText("white");

    const onScroll = () => {
      if (window.scrollY > 80) {
        setNavBackground("white");
        setNavText("black");
      } else {
        setNavBackground("transparent");
        setNavText("white");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      setNavBackground("white");
      setNavText("black");
    };
    // carousel_images.forEach((picture) => {
    //     const img = new Image();
    //     img.src = picture.fileName;
    //     window[picture] = img;
    // });
  }, []);

  useEffect(() => {
    handleScroll();
  }, [isScrollingUp, isScrollingDown, isScrolling]);
  useEffect(() => {
    window.dataLayer.push({
      event_name: "pageview",
      page: {
        title: "Home Page",
      },
    });
  }, []);
  return (
    <div className="home-container">
      <div className="carousel-container" style={{
        // 90vh (not 100) on mobile only, and a static vh unit rather than
        // dvh — leaves headroom so the mobile browser's own address/nav
        // bar never covers the bottom-anchored overlay text below,
        // without the resize jump dvh causes as that bar shows/hides on
        // scroll. Desktop keeps the full 100vh since there's no such bar.
        height: max_width ? "90vh" : "100vh",
        marginTop: "-100px",
        position: 'relative'
      }}>

        <Swiper
          slidesPerView={1}
          loop={true}
          speed={1200}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          allowTouchMove={false}
          modules={[Autoplay, EffectFade]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {
            (max_width ? carousel_images_mobile : carousel_images).map((src, i) => (
              <SwiperSlide key={i}>
                <div style={{
                height: max_width ? "90vh" : "100vh",
                width: "100%",
                overflow: "hidden",
                }}>
                  <img
                    className={`home-${i}-img`}
                    style={{
                      width: "100%", // //Full width of container
                      height: "100%", // Full height of container
                      objectFit: "cover", // Cover the container
                      objectPosition: "center 50%" // Center the image
                    }}
                    loading="lazy"
                    src={src}
                    id={max_width ? `home-${i}-img-mobile` : `home-${i}-img`}
                    alt="Galerie Property Image."
                  />
                </div>
              </SwiperSlide>
            ))
          }
        </Swiper>

        <div className="carousel-hero-overlay">
          <h2 className="carousel-hero-overlay-text">
            <span>More Good</span>
            <TypewriterWord />
          </h2>
        </div>

        {SHOW_HOME_STATES_HIGHLIGHT && <HomeStatesHighlight />}
      </div>

      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div
        className="hero-text-overlay"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'left',
          width: '100%',
          marginTop: '100px',
          gap: '16px'
        }}>
          <p className="health-header-title home-mission-label">Our Mission</p>
          <h1 className="home-hero-title">
            Creating <span style={{ color: "#00965e" }}>more good days</span>{" "}
            for seniors, families, and communities
          </h1>
        </div>
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="capital-hero home-hero-about-btn-wrap">
          <DarkRedButton
            class_name="home-about-btn"
            btnText={"About Us"}
            btnLink={"/ourstory"}
            data_test_id="home-about-btn"
          />
          <DarkRedButton
            class_name="home-explore-communities-btn"
            btnText={"Explore Communities"}
            btnLink={"/portfolio"}
            data_test_id="home-explore-communities-btn"
          />
        </div>
      </Parallax>

      {/* <PropertyMap /> */}

      {/* <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="home-companies">
          <p className="home-companies-subhead">Companies</p>
          <h3 className="home-companies-text">
            As owners, developers, and operators, our vertically-integrated family of companies establishes a collabrative union
            that embodies bold strategy, visionary foresight, and class-redefining leadership.
          </h3>
          <div className="home-companies-cards-div">
            <motion.div
              className="home-companies-card"
              onMouseOver={() => hoverCard("capital")}
              onMouseOut={() => hoverCard(false)}
              initial={
                max_width2
                  ? { opacity: 1, y: 0 }
                  : scroll
                  ? { opacity: 0, y: -75 }
                  : { opacity: 0, y: 75 }
              }
              whileInView={{ opacity: 1, y: 0 }}
              transition={
                max_width2 ? { duration: 0 } : { type: "tween", duration: 0.5 }
              }
            >
              <Link to="/capital" data-testid="home-capital-card">
                <img
                  id={
                    max_width
                      ? "galerieCapitalHomeCard-mobile"
                      : "galerieCapitalHomeCard"
                  }
                  alt="Galerie Living team conversing with Galerie Capital Logo overlay."
                  data-testid="home-capital-card"
                  width="360"
                  height="500"
                />
              </Link>
              <Link
                to="/capital"
                className="home-companies-card-body"
                style={
                  hoverColor === "capital"
                    ? { color: "#A12A2B", textDecoration: "none" }
                    : { color: "black", textDecoration: "none" }
                }
                data-testid="home-capital-card"
              >
                <p>galerie capital</p>
                <ArrowUpRight size={20} />
              </Link>
            </motion.div>
            <motion.div
              className="home-companies-card"
              onMouseOver={() => hoverCard("dev")}
              onMouseOut={() => hoverCard(false)}
              initial={
                max_width2
                  ? { opacity: 1, y: 0 }
                  : scroll
                  ? { opacity: 0, y: -75 }
                  : { opacity: 0, y: 75 }
              }
              whileInView={{ opacity: 1, y: 0 }}
              transition={
                max_width2
                  ? { duration: 0 }
                  : { type: "tween", duration: 0.5, delay: 0.2 }
              }
            >
              <Link to="/development" data-testid="home-development-card">
                <img
                  id={
                    max_width
                      ? "galerieDevelopmentHomeCard-mobile"
                      : "galerieDevelopmentHomeCard"
                  }
                  alt="Corso Atlanta sketch in front of Corso Atlanta Building with Galerie Development Logo overlay"
                  data-testid="home-development-card"
                  width="360"
                  height="500"
                />
              </Link>
              <Link
                to="/development"
                className="home-companies-card-body"
                style={
                  hoverColor === "dev"
                    ? { color: "#A12A2B", textDecoration: "none" }
                    : { color: "black", textDecoration: "none" }
                }
                data-testid="home-development-card"
              >
                <p>galerie Development</p>
                <ArrowUpRight size={20} />
              </Link>
            </motion.div>
            <motion.div
              className="home-companies-card"
              onMouseOver={() => hoverCard("management")}
              onMouseOut={() => hoverCard(false)}
              initial={
                max_width2
                  ? { opacity: 1, y: 0 }
                  : scroll
                  ? { opacity: 0, y: -75 }
                  : { opacity: 0, y: 75 }
              }
              whileInView={{ opacity: 1, y: 0 }}
              transition={
                max_width2
                  ? { duration: 0 }
                  : { type: "tween", duration: 0.5, delay: 0.3 }
              }
            >
              <Link to="/management" data-testid="home-management-card">
                <img
                  id={
                    max_width
                      ? "galerieManagementHomeCard-mobile"
                      : "galerieManagementHomeCard"
                  }
                  alt="Nurse and patient smiling and looking at a tablet with Galerie Management Logo overlay"
                  data-testid="home-management-card"
                  width="360"
                  height="500"
                />
              </Link>
              <Link
                to="/management"
                className="home-companies-card-body"
                style={
                  hoverColor === "management"
                    ? { color: "#A12A2B", textDecoration: "none" }
                    : { color: "black", textDecoration: "none" }
                }
                data-testid="home-management-card"
              >
                <p>galerie Management</p>
                <ArrowUpRight size={20} />
              </Link>
            </motion.div>
          </div>
        </div>
      </Parallax> */}

      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CoreStackSlider />
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <GalerieProjectsSlider
          title="The Future Of Galerie"
          subhead="What's Next"
          slidesPerView={3}
          class_name="home-projects-teaser"
        />
      </Parallax>

      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <VideoTestimonial
          storage={storage}
          background_color="#041C2C"
          text_color="white"
          db={db}
          class_name="home-page-testimonials"
        />
      </Parallax>

      {/* ── "The Faces of Galerie" card (commented out) ──
      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardGrey
          imgId={max_width ? "home-card-1-img-mobile" : "home-card-1-img"}
          cardTitle={"The Faces of Galerie"}
          cardText={
            "Our team of established visionaries and industry trailblazers bring a united vision of better senior living to fruition through a commitment to excellent intent, approach, and execution."
          }
          buttonLink={"/team"}
          buttonText={"The Team"}
          flexStyle={"row-reverse"}
          class_name={"home-card-2"}
          data_test_id="home-faces-of-galerie-btn"
          alt_tag="Galerie Living team smiling outside of Corso Atlanta Senior Living Building."
        />
      </Parallax>
      */}
      {/* ── "A History of Happiness" card (commented out) ──
      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <CardWhite
          imgId={max_width ? "home-card-2-img-mobile" : "home-card-2-img"}
          cardTitle={"A History of Happiness"}
          cardText={
            "Our expanding track record has propelled our brand to the forefront of numerous esteemed publications. For insights into our vision, values, and upcoming developments, see Galerie in the Press."
          }
          buttonLink={"/press"}
          buttonText={"Galerie in the press"}
          flexStyle={"row"}
          class_name={"home-card-1"}
          data_test_id="home-galerie-in-press-btn"
          alt_tag="Exterior of Corso Atlanta Senior Living Building."
        />
      </Parallax>
      ── END "A History of Happiness" ── */}

      {/* ── "The Collection" section (commented out) ──
      <div className="contact-us-collection-container">
        <h1 className="home-collection-title">The Collection</h1>
        <div className="contact-collection-card-container">
          <motion.div
            className="contact-collection-card"
            onMouseOver={() => hoverCard("corso")}
            onMouseOut={() => hoverCard(false)}
            initial={
              max_width2
                ? { opacity: 1, y: 0 }
                : scroll
                ? { opacity: 0, y: -75 }
                : { opacity: 0, y: 75 }
            }
            whileInView={{ opacity: 1, y: 0 }}
            transition={
              max_width2 ? { duration: 0 } : { type: "tween", duration: 0.5 }
            }
          >
            <Link to="/corso" data-testid="home-corso-card">
              <img
                loading="lazy"
                id={
                  max_width
                    ? "collection-mobile-corso"
                    : "collection-desktop-corso"
                }
                className="contact-img"
                alt="Exterior of Corso Atlanta Senior Living Building with the Corso Logo overlaid."
                data-testid="home-corso-card"
                width="640"
                height="360"
              />
            </Link>
            <Link
              to="/corso"
              className="contact-collection-card-text"
              style={
                hoverColor === "corso"
                  ? { color: "#A12A2B", textDecoration: "none" }
                  : { color: "black", textDecoration: "none" }
              }
              data-testid="home-corso-card"
            >
              <p>Corso</p>
              <ArrowUpRight className="contact-arrow-icon" size={20} />
            </Link>
          </motion.div>
          <motion.div
            className="contact-collection-card"
            onMouseOver={() => hoverCard("vp")}
            onMouseOut={() => hoverCard(false)}
            initial={
              max_width2
                ? { opacity: 1, y: 0 }
                : scroll
                ? { opacity: 0, y: -75 }
                : { opacity: 0, y: 75 }
            }
            whileInView={{ opacity: 1, y: 0 }}
            transition={
              max_width2
                ? { duration: 0 }
                : { type: "tween", duration: 0.5, delay: 0.2 }
            }
          >
            <Link to="/villagepark" data-testid="home-vp-card">
              <img
                loading="lazy"
                id={
                  max_width ? "collection-mobile-vp" : "collection-desktop-vp"
                }
                className="contact-img"
                alt="Exterior of Village Park Senior Living Building with the Village Park Logo overlaid."
                data-testid="home-vp-card"
                width="640"
                height="360"
              />
            </Link>
            <Link
              className="contact-collection-card-text"
              to="/villagepark"
              style={
                hoverColor === "vp"
                  ? { color: "#A12A2B", textDecoration: "none" }
                  : { color: "black", textDecoration: "none" }
              }
              data-testid="home-vp-card"
            >
              <p>Village Park</p>
              <ArrowUpRight className="contact-arrow-icon" size={20} />
            </Link>
          </motion.div>
        </div>
      </div>
      ── END "The Collection" ── */}

      <div className="home-divider"></div>
      <Parallax
        translateY={max_width2 ? [0, 0] : ["150px", "0px"]}
        easing={[0.25, 1, 0.25, 1]}
      >
        <div className="home-more-info">
          <h1 className="home-more-info-title">Need More Information?</h1>
          <p className="home-more-info-text">
            We're happy to help. Whether you have questions, feedback, or just
            want to say hello, please don't hesitate to reach out. We'd love to
            hear from you and assist in any way we can.
          </p>
          <div>
            <DarkRedButton
              class_name="home-more-info-btn"
              btnLink={"/contact"}
              btnText={"Contact Us"}
              data_test_id="home-contact-btn"
            />
          </div>
        </div>
      </Parallax>
    </div>
  );
}
